import {
  SmartToy,
} from '@material-ui/icons';

import paths from 'paths';
import { ccTypes } from 'store/constant';

export default {
  id: 'suggestion-menu',
  type: 'group',
  children: [
    {
      id: 'suggestion',
      title: 'AI suggestion',
      type: 'item',
      url: `${paths.suggestion.reverse()}`,
      icon: SmartToy,
      breadcrumbs: false,
      ccTypesAllowed: [ccTypes.internal],
    },
  ],
};
